import axios from '@hw-core/libs/axios'
import { db } from '@/shared/services/firebase'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInvoices(ctx, { accountId, status }) {
      return new Promise((resolve, reject) => {
        db.collection('invoices')
          .where('accountId', '==', accountId)
          .where('status', '==', status)
          .orderBy('date', 'desc')
          .limit(50)
          .get()
          .then(snapshot => {
            const data = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              return item
            })
            resolve({ data })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchContractInvoices(ctx, { contractId }) {
      return new Promise((resolve, reject) => {
        db.collection('invoices')
          .where('contractId', '==', contractId)
          .get()
          .then(snapshot => {
            const { length } = snapshot.docs
            resolve({ length })
          })
          .catch(() => {
            reject()
          })
      })
    },
    fetchAreas(ctx, { accountId }) {
      return new Promise((resolve, reject) => {
        db.collection('areas')
          .where('accountId', '==', accountId)
          .get()
          .then(snapshot => {
            const data = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              return item
            })
            resolve({ data })
          })
          .catch(() => {
            reject()
          })
      })
    },
    fetchInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        db.collection('invoices')
          .doc(id)
          .get()
          .then(doc => {
            const data = doc.data()
            data.id = id
            resolve({ ...data, client: data })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    createInvoice(ctx, { invoice }) {
      return new Promise((resolve, reject) => {
        db.collection('invoices').add({ ...invoice })
          .then(() => {
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateInvoice(ctx, {
      id,
      date,
      dueDate,
      total,
      items,
    }) {
      return new Promise((resolve, reject) => {
        db.collection('invoices').doc(id).update({
          date,
          dueDate,
          total,
          items,
        })
          .then(() => {
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    deleteInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        db.collection('invoices').doc(id).update({
          status: 'deleted',
        })
          .then(() => {
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchClients() {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/invoice/clients')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchContract(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const query = db.collection('contracts')
          .doc(id)
        query
          .get()
          .then(async doc => {
            const data = doc.data()
            data.id = doc.id
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchUser(ctx, { userId }) {
      
      return new Promise((resolve, reject) => {
        
        db.collection('users')
          .doc(userId)
          .get()
          .then( doc => {
            const data = doc.data()
            data.role = ctx.rootGetters.userRole(data.role)
            data.id = doc.id
            resolve({ data })
          })
          .catch(() => {
            reject()
          })
      })
    },
    fetchInvoiceShifts(ctx, { areaId, from, to }) {
      return new Promise((resolve, reject) => {
        db.collection('shifts')
          .where('areaId', '==', areaId)
          .where('status', '==', 'confirmed')
          .where('workDayType', '==', 'work')
          .where('start', '>=', from)
          .where('start', '<', to)
          .get()
          .then(async snapshot => {
            const data = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              item.start = item.start.toDate()
              item.end = item.end.toDate()
              return item
            })
            resolve({ data })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    editTempGig(ctx, { id, contractId }) {
      return new Promise((resolve, reject) => {
        db.collection('gigs').doc(id).update({
          contract: contractId,
        })
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    fetchContractGigsTemp() {
      return new Promise((resolve, reject) => {
        db.collection('gigs')
          .get()
          .then(async snapshot => {
            const data = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              return item
            })
            resolve({ data })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchGigsTemp() {
      return new Promise((resolve, reject) => {
        db.collection('gigs')
          .where('isTemplate', '==', false)
          .get()
          .then(async snapshot => {
            const data = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              return item
            })
            resolve({ data })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchArea(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const query = db.collection('areas')
          .doc(id)
        query
          .get()
          .then(async doc => {
            const data = doc.data()
            data.id = doc.id
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchGigShifts(ctx, { id }) {
      return new Promise((resolve, reject) => {
        db.collection('shifts')
          .where('gigId', '==', id)
          .get()
          .then(async snapshot => {
            const data = snapshot.docs.map(doc => doc.id)
            resolve(data)
          })
          .catch(() => {
            reject()
          })
      })
    },
    updateShift(ctx, { id, contractId }) {
      return new Promise((resolve, reject) => {
        db.collection('shifts').doc(id).update({
          contractId,
        })
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    fetchBankDetails() {
      return new Promise((resolve, reject) => {
        const query = db.collection('bankDetails').doc('tAPzJiOPGXBtVhd6EVRW')
        query
          .get()
          .then(doc => {
            if (!doc.exists) {
              reject()
            }
            const data = doc.data()
            resolve({ data })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchShifts(ctx, { from, to, accountId }) {
      return new Promise((resolve, reject) => {
        db.collection('shifts')
          .where('status', '==', 'confirmed')
          .where('start', '>=', from)
          .where('start', '<=', to)
          .where('accountId', '==', accountId)
          .get()
          .then(snapshot => {
            const data = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              item.start = item.start.toDate()
              item.end = item.end.toDate()
              return item
            })
            resolve({ data })
          })
          .catch(() => {
            reject()
          })
      })
    },
    markAsPaid(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        db.collection('invoices').doc(id).update({ status })
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    // addUser(ctx, userData) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .post('/apps/user/users', { user: userData })
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
  },
}
